module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-US":{"title_new":"New User","title_edit":"Edit User","buttons":{"cancel":"Cancel","save":"Save"},"alerts":{"new":"User created successfully!","edit":"User updated successfully!"}},"pt-BR":{"title_new":"Novo Usuário","title_edit":"Editar Usuário","buttons":{"cancel":"Cancelar","save":"Salvar"},"alerts":{"new":"Usuário criado com sucesso!","edit":"Usuário atualizado com sucesso!"}}}')
  delete Component.options._Ctor
}
